import {
  DC_Products_Client_Old_Client_Models_BuildingCategory,
  DC_Products_Client_Old_Client_Models_BuildingSubCategory,
} from '@monorepo-types/dc';

export enum BusinessCategoriesValues {
  autobedrijf_autoschadeherstelbedrijven = 'CarRepairShop',
  autobedrijf_showroom_en_garage = 'CarShowroom',
  detailhandel_met_koeling = 'RetailWithCooling',
  detailhandel_zonder_koeling = 'RetailWithoutCooling',
  gezondheidszorg_bijeenkomst = 'HealthcareMeeting',
  gezondheidszorg_praktijk = 'HealthcarePractice',
  gezondheidszorg_tehuis = 'HealthcareHome',
  horeca_cafe = 'HospitalityCafe',
  horeca_cafetaria = 'HospitalitySnackBar',
  horeca_hotels_motels = 'HospitalityHotelsMotels',
  horeca_restaurant = 'HospitalityRestaurant',
  kantoor_overheid = 'OfficeGovernment',
  kantoor_overig = 'OfficeOther',
  onderwijs_primair = 'EducationPrimary',
  overig_haar_en_schoonheidsverzorging = 'OtherBeautyCare',
  overig_religie = 'OtherReligion',
  recreatie_binnensport = 'RecreationIndoorSports',
  recreatie_buitensport = 'RecreationOutdoorSports',
  recreatie_vereniging = 'RecreationClub',
  recreatie_zwembad = 'RecreationPool',
}

export enum Installments {
  SOLAR_PANELS = 'SolarPanel',
  ROOF_ISOLATION = 'InsulationRoof',
  UNKNOWN = 'Unknown',
}

export enum BuildingCategoriesEnum {
  Office = 'Office',
  Hospitality = 'Hospitality',
  Shop = 'Shop',
  Wholesale = 'Wholesale',
  Automotive = 'Automotive',
  Healthcare = 'Healthcare',
  Recreation = 'Recreation',
  Education = 'Education',
  Other = 'Other',
}

export enum BuildingSubCategoriesEnum {
  ShowroomAndGarage = 'ShowroomAndGarage',
  RepairShop = 'RepairShop',
  DayCareOrCommunityCenter = 'DayCareOrCommunityCenter',
  BeautyCare = 'BeautyCare',
  Association = 'Association',
  PrimarySchool = 'PrimarySchool',
  NursingHome = 'NursingHome',
  OutdoorSports = 'OutdoorSports',
  IndoorSports = 'IndoorSports',
  WithCoolingSupermarket = 'WithCoolingSupermarket',
  WithCoolingFishProcessing = 'WithCoolingFishProcessing',
  WithoutCoolingDrugstore = 'WithoutCoolingDrugstore',
  WithoutCoolingStorage = 'WithoutCoolingStorage',
  Religion = 'Religion',
  Practice = 'Practice',
  SwimmingPool = 'SwimmingPool',
  None = 'None',
  OTHER = 'Other',
}

export const buildingCategoriesInOrder: DC_Products_Client_Old_Client_Models_BuildingCategory[] = [
  'Office',
  'Hospitality',
  'Shop',
  'Wholesale',
  'Automotive',
  'Healthcare',
  'Recreation',
  'Education',
  'Other',
];

export type CategoryWithSubCategory = {
  subcategory: DC_Products_Client_Old_Client_Models_BuildingSubCategory | BuildingSubCategoriesEnum.OTHER;
  category: DC_Products_Client_Old_Client_Models_BuildingCategory;
};

export type CategoriesWithSubCategories = {
  [key in BuildingCategoriesEnum]?: CategoryWithSubCategory[];
};

export const categoriesWithOrderedSubCategories: CategoriesWithSubCategories = {
  [BuildingCategoriesEnum.Office]: [],
  [BuildingCategoriesEnum.Hospitality]: [],
  [BuildingCategoriesEnum.Shop]: [
    { subcategory: BuildingSubCategoriesEnum.WithCoolingSupermarket, category: BuildingCategoriesEnum.Shop },
    { subcategory: BuildingSubCategoriesEnum.WithoutCoolingDrugstore, category: BuildingCategoriesEnum.Shop },
  ],
  [BuildingCategoriesEnum.Wholesale]: [
    { subcategory: BuildingSubCategoriesEnum.WithCoolingFishProcessing, category: BuildingCategoriesEnum.Wholesale },
    { subcategory: BuildingSubCategoriesEnum.WithoutCoolingStorage, category: BuildingCategoriesEnum.Wholesale },
  ],
  [BuildingCategoriesEnum.Automotive]: [
    { subcategory: BuildingSubCategoriesEnum.RepairShop, category: BuildingCategoriesEnum.Automotive },
    { subcategory: BuildingSubCategoriesEnum.ShowroomAndGarage, category: BuildingCategoriesEnum.Automotive },
  ],
  [BuildingCategoriesEnum.Healthcare]: [
    { subcategory: BuildingSubCategoriesEnum.Practice, category: BuildingCategoriesEnum.Healthcare },
    { subcategory: BuildingSubCategoriesEnum.NursingHome, category: BuildingCategoriesEnum.Healthcare },
  ],
  [BuildingCategoriesEnum.Recreation]: [
    { subcategory: BuildingSubCategoriesEnum.IndoorSports, category: BuildingCategoriesEnum.Recreation },
    { subcategory: BuildingSubCategoriesEnum.OutdoorSports, category: BuildingCategoriesEnum.Recreation },
    { subcategory: BuildingSubCategoriesEnum.Association, category: BuildingCategoriesEnum.Recreation },
    { subcategory: BuildingSubCategoriesEnum.SwimmingPool, category: BuildingCategoriesEnum.Recreation },
  ],
  [BuildingCategoriesEnum.Education]: [
    { subcategory: BuildingSubCategoriesEnum.PrimarySchool, category: BuildingCategoriesEnum.Education },
  ],
  [BuildingCategoriesEnum.Other]: [
    { subcategory: BuildingSubCategoriesEnum.BeautyCare, category: BuildingCategoriesEnum.Other },
    { subcategory: BuildingSubCategoriesEnum.DayCareOrCommunityCenter, category: BuildingCategoriesEnum.Other },
    { subcategory: BuildingSubCategoriesEnum.Religion, category: BuildingCategoriesEnum.Other },
    { subcategory: BuildingSubCategoriesEnum.OTHER, category: BuildingCategoriesEnum.Other },
  ],
};
